import { Tooltip } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';

import { ReactComponent as CloseIcon } from '@assets/icons/close.svg';

import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { getShortName } from '@utils/Util';

const SelectedFabric = ({ materials, moodboardId }) => {
	const dispatch = useDispatch();

	const onRemoveMaterial = async (materialId) => {
		dispatch(openLoader());
		let params = `${moodboardId}/material/${materialId}`;
		await ApiClient.DELETE('moodboardAction', {}, params)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.REMOVE_FABRIC_FROM_MOODBOARD,
						payload: materialId
					});
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<div className="moodboard-fabric-container">
			<h3>Selected fabrics</h3>
			<div className="fabric-all-items">
				{materials?.map((item) => (
					<div className="fabric-single-item" key={item.id}>
						<div className="fabric-image">
							{item?.documentPath ? (
								<img src={item?.documentPath} alt="item" className="material-image" />
							) : (
								<img
									src={`${process.env.PUBLIC_URL}/icons/fabric-defauld.svg`}
									alt=""
									className="material-image"
								/>
							)}
							{/* <img src={item?.documentPath} alt="fabric" /> */}
							<span className="close" onClick={() => onRemoveMaterial(item.id)}>
								<CloseIcon />
							</span>
						</div>
						<Tooltip
							title={<h5 className="font-12">{item?.name}</h5>}
							placement="top"
							arrow
							className="cursor-pointer"
						>
							<p>{getShortName(item?.name, 40)}</p>
						</Tooltip>
					</div>
				))}
			</div>
		</div>
	);
};

export default SelectedFabric;
